export default {
  queued: 'Na fila',
  running: 'Em execução',
  retry_wait: 'Aguardando nova tentativa',
  success: 'Sucesso',
  failed: 'Falha',
  canceled: 'Cancelado',
};
